import moment from "moment";
import { useContext, useEffect, useMemo, useState } from "react";
import { AvisConstants } from "../../../../data/avisConstants";
import { AdditionalPublicData } from "../../../../generated/data-contracts";
import { api } from "../../../../utils";
import { AvisContext } from "../../context/AvisContext";
import { AvisLoader } from "../loader/AvisLoader";

interface IAvisDataRenewDateProps {
  dataType: keyof AdditionalPublicData;
}
export function AvisDataRenewDate(props: Readonly<IAvisDataRenewDateProps>) {
  const { res } = useContext(AvisContext);
  const [updateDates, setUpdateDates] = useState<AdditionalPublicData>();
  const { dataType } = props;

  useEffect(() => {
    api.publicGetPublicRegisterUpdateDate().then((res) => {
      setUpdateDates(res.data);
    });
  }, []);

  const updateDateValue = useMemo(() => {
    if (!updateDates) return "";

    return (
      moment(updateDates[dataType]).format(AvisConstants.date_format) || ""
    );
  }, [dataType, updateDates]);

  if (!updateDates) return <AvisLoader inline />;

  return <div>{res("label_DataRenewDate", updateDateValue)}</div>;
}
